export const BRAND = {
  name: "Yes Global Consultants",
  logo: "/logo.jpg",
  phone: "+91-9910544588",
  email: "bharat.uprati@gmail.com",
  location: "New Delhi, India",
};

export const IMAGES = {
  founder: "/founder.jpg",
  office:
    "https://images.unsplash.com/photo-1706074793638-da28b90ea8ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBvZmZpY2UlMjBpbnRlcmlvciUyMG1vZGVybnxlbnwwfHx8fDE3ODUyNDQ0ODd8MA&ixlib=rb-4.1.0&q=85",
  skyline:
    "https://images.pexels.com/photos/19612315/pexels-photo-19612315.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    no: "01",
    title: "Executive Search",
    tagline: "Leadership, engineered.",
    desc: "We identify, assess and secure transformational C-suite and board-level leaders. A discreet, research-led search process built on 18+ years of global talent architecture across India, the UAE and the US.",
    points: ["CXO & Board Search", "Succession Modeling", "Talent Ring-Fencing", "Leadership Assessment"],
  },
  {
    no: "02",
    title: "HR Consulting",
    tagline: "Culture, by design.",
    desc: "End-to-end strategic HR — from organizational design and predictive attrition modeling to multi-country compliance and HRIS modernization. We turn people strategy into measurable business advantage.",
    points: ["Org Design & Change", "HR Analytics & HRIS", "Global Compliance & Payroll", "Culture & ESG"],
  },
];

export const PROCESS = [
  { no: "01", title: "Discover", desc: "Deep mandate calibration — mapping culture, role architecture and the exact leadership DNA required." },
  { no: "02", title: "Map", desc: "Confidential market intelligence and targeted research across global talent pools." },
  { no: "03", title: "Assess", desc: "Rigorous competency, psychometric and leadership evaluation against your success profile." },
  { no: "04", title: "Secure", desc: "Discreet engagement, negotiation and onboarding — with post-placement assurance." },
];

export const INDUSTRIES = [
  "IT & Consulting", "Healthcare", "Media & Entertainment", "Electronics Manufacturing",
  "Logistics & Supply Chain", "BFSI", "Retail & FMCG", "Real Estate",
];

export const STATS = [
  { value: "18+", label: "Years of Global Leadership" },
  { value: "100+", label: "Leaders Placed" },
  { value: "03", label: "Regions — India · UAE · US" },
  { value: "07", label: "Industry Awards Won" },
];

export const AWARDS = [
  "CHRO Excellence Award 2026",
  "Top 100 HR Leaders — Delhi-NCR 2026",
  "Noida's Top 26 HR Leaders 2026",
  "Strategic HR Leadership Excellence 2026",
  "HR Super Achiever Award 2025",
];

export const FOUNDER = {
  name: "Bharat Chander Uprati",
  role: "Founder · Director & Head of HR",
  linkedin: "https://www.linkedin.com/in/chanderhr/",
  quote:
    "Great organizations aren't staffed — they are architected. We place leaders who reshape culture and compound value.",
  bio: "A multi-award-winning HR strategist with 18+ years of global experience in organizational development, talent architecture and corporate governance. Bharat has steered HR operations and compliance across India, the UAE and the US, leveraging advanced analytics to drive transformation in high-growth ecosystems.",
  creds: ["MBA (HR), Symbiosis Pune", "HR Analytics — IIM Rohtak", "Zero-infraction cross-border compliance"],
};

export const TEAM = [
  { name: "Jerry Shane", role: "Talent Partner", linkedin: "https://www.linkedin.com/in/jerry-shane-a39151422/", initials: "JS" },
  { name: "Manish Sharma", role: "Search Consultant", linkedin: "https://www.linkedin.com/in/manish-sharma-5114a6176/", initials: "MS" },
  { name: "Gauri Sharma", role: "Client Success", linkedin: "https://www.linkedin.com/in/yescorp/", initials: "GS" },
];

export const NAV = [
  { label: "Services", href: "#services" },
  { label: "Founder", href: "#founder" },
  { label: "Team", href: "#team" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];
